import { render, staticRenderFns } from "./BannerFormPage.vue?vue&type=template&id=2588a05a&scoped=true"
import script from "./BannerFormPage.vue?vue&type=script&lang=js"
export * from "./BannerFormPage.vue?vue&type=script&lang=js"
import style0 from "./BannerFormPage.vue?vue&type=style&index=0&id=2588a05a&prod&scoped=true&lang=css"
import style1 from "./BannerFormPage.vue?vue&type=style&index=1&id=2588a05a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2588a05a",
  null
  
)

export default component.exports